module.exports = __webpack_public_path__ + "img/1 (13).5781f2e1.jpg";